import clsx from "clsx";
import type { CaseView } from "./caseView";
import styles from "./Loupe.module.scss";

/* UI-DESIGN: LB-15 the magnifier from the hero, put to work: over a slide
   it becomes a loupe that follows the cursor. The scene magnifies the
   slide inside the lens (2x) and writes the lens position and size onto
   this element; the page only says which case it is over, so the label
   can carry that case's tagline. Decorative for assistive tech: the same
   tagline is in the case's card. */
type LoupeProps = {
  view: CaseView | null;
};

const Loupe = ({ view }: LoupeProps) => (
  <div className={clsx(styles.loupe, view && styles.on)} data-lb-loupe="" aria-hidden>
    <span className={styles.ring} />
    <span className={styles.handle} />
    {/* UI-DESIGN: LB-24 the lens only: the label beside it repeated the
        case card (name and tagline), so it is cut */}
  </div>
);

export default Loupe;
